export default __webpack_public_path__ + "static/media/logo.72864e76.png";